import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import PrecisionManufacturingRoundedIcon from "@mui/icons-material/PrecisionManufacturingRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { GUN_OPTIONS } from "../utils/constants";
import { tacticalActionSx, tacticalSurface } from "../utils/fdcTheme";

export default function GunSetupPage() {
  const theme = useTheme();
  const navigate = useNavigate();

  const [gunNumber, setGunNumber] = useState(() => {
    try {
      return localStorage.getItem("guncmd_myGun") || "";
    } catch {
      return "";
    }
  });

  // If gun already selected, go straight to main page
  useEffect(() => {
    try {
      const saved = localStorage.getItem("guncmd_myGun");
      if (saved) navigate("/guncmd", { replace: true });
    } catch {
      // ignore
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleContinue = () => {
    if (!gunNumber) return;
    try {
      localStorage.setItem("guncmd_myGun", gunNumber);
    } catch {
      // ignore
    }
    navigate("/guncmd/position");
  };

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 4, sm: 8 } }}>
      <Box
        sx={{
          ...tacticalSurface(theme, true),
          borderRadius: 3,
          p: { xs: 3, sm: 4 },
          textAlign: "center",
        }}
      >
        <PrecisionManufacturingRoundedIcon
          sx={{ fontSize: 48, color: "text.secondary", mb: 2 }}
        />

        <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>
          Identify Your Gun
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "text.secondary", mb: 3 }}
        >
          Select the gun you are commanding. This is saved locally so you
          don't need to re-select every time.
        </Typography>

        <FormControl fullWidth size="medium" sx={{ mb: 3 }}>
          <InputLabel id="setup-gun-label">My Gun</InputLabel>
          <Select
            labelId="setup-gun-label"
            label="My Gun"
            value={gunNumber}
            onChange={(e) => setGunNumber(e.target.value)}
            sx={{
              borderRadius: 2,
              fontWeight: 600,
              fontSize: 18,
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: alpha(theme.palette.divider, 0.8),
              },
            }}
          >
            {GUN_OPTIONS.map((g) => (
              <MenuItem key={g.value} value={g.value}>
                {g.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          fullWidth
          variant="contained"
          size="large"
          disabled={!gunNumber}
          onClick={handleContinue}
          endIcon={<ArrowForwardRoundedIcon />}
          sx={{
            ...tacticalActionSx(theme, "success", "contained"),
            py: 1.5,
            fontSize: 16,
            fontWeight: 700,
          }}
        >
          Continue to Position
        </Button>
      </Box>
    </Container>
  );
}
